import { ChartBarIcon } from './ChartBarIcon';

/**
 * author: Austin Andrews
 * id 85D4DC49-5359-4867-A5D1-52C44699387F
 * name chart-bar
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-bar.svg
 * tags
 * - Math 
 */
export const GraphBarIcon = ChartBarIcon;
export default GraphBarIcon